import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "../../app/hook";
import { useRefreshTokenMutation } from "../../app/services/auth-rtk.service";
import { login, selectUserAuthStatus } from "../../features/auth/auth.slice";
import LoadingComponent from "./loading/loading.component";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAppSelector(selectUserAuthStatus);
  const [isLoading, setIsLoading] = useState(true);
  const [refreshTokenRequest, refreshTokenRequestStatus] =
    useRefreshTokenMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      const refreshToken = localStorage.getItem(
        `${import.meta.env.VITE_STORAGE_PREFIX}_refresh_token`
      );

      if (refreshToken) {
        setIsLoading(true);

        refreshTokenRequest({
          refresh_token: refreshToken
        })
          .unwrap()
          .then((res) => {
            localStorage.setItem(
              `${import.meta.env.VITE_STORAGE_PREFIX}_refresh_token`,
              res.element.refresh_token
            );
            localStorage.setItem(
              `${import.meta.env.VITE_STORAGE_PREFIX}_token`,
              res.element.access_token
            );
            dispatch(
              login({
                is_remember_me: true
              })
            );
            window.location.reload();
          })
          .catch((error) => {
            navigate("../login", { replace: true });
          });
      } else {
        navigate("../login", { replace: true });
      }
    } else {
      setIsLoading(false);
    }
  }, [isAuthenticated]);

  if (isLoading) return <LoadingComponent />;
  else return <React.Fragment>{children}</React.Fragment>;
};

export default PrivateRoute;
